import React from "react";
import "../App.css";

export default class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        about: props.about,
    }
  }

  render() {
    return (
        <p className="about">
            {this.state.about ? this.state.about : 'This user does not currently have an "About Me".'}
        </p>
    );
  }
}
